// Default boilerplate content for each document type.
// When creating a new document from a template, these values pre-populate the form.
// Users can edit before saving. All text is in Japanese, aligned with
// 訪問看護 standard documentation practice in Japan.

export const DEFAULT_CONTENT = {
  // === 申込・契約 ===
  application: {
    urgency: "通常",
    service_type: "介護保険",
    frequency: "週1〜2回(主治医指示書に基づく)",
    purpose: "在宅において療養生活を安定して送るため、訪問看護による健康管理・療養上の世話・医療処置の提供を希望する。",
    current_condition: "主治医の指示に基づき、在宅での医療的ケアが必要な状態。\n家族の介護負担軽減を含めた支援が求められる。",
  },

  important_matters: {
    service_description: "当訪問看護ステーションは、主治医の指示書に基づき、利用者宅を訪問し、療養上の世話及び診療の補助を行います。主な提供内容は以下のとおりです。\n\n① 健康状態の観察・バイタルサインの測定\n② 病状の管理・療養上の助言及び指導\n③ 医師の指示による医療処置(点滴、褥瘡処置、カテーテル管理、吸引、酸素療法管理 等)\n④ 服薬管理・服薬指導\n⑤ リハビリテーション(理学療法士・作業療法士・言語聴覚士配置時)\n⑥ 精神科訪問看護(精神科主治医指示書がある場合)\n⑦ ターミナルケア・看取り\n⑧ ご家族への介護相談・指導",
    staff_composition: "看護師、准看護師、保健師、理学療法士、作業療法士、言語聴覚士、事務員により構成されています。職員体制は運営規程に定めるとおりです。",
    business_area: "当事業所の実施地域は、事業所所在市区町村及び隣接市区町村です。",
    fee_care_insurance: "介護保険の給付対象となる訪問看護費用は、所定単位数に1割〜3割(所得に応じた負担割合)を乗じた額をご負担いただきます。訪問看護費の算定は、訪問看護計画に基づき、所要時間区分により算定します。",
    fee_medical_insurance: "医療保険の給付対象となる訪問看護費用は、訪問看護療養費として算定し、自己負担割合(1割〜3割)に応じた額をご負担いただきます。",
    fee_self_pay: "以下は自費のご負担となります。\n・実施地域を超える訪問にかかる交通費\n・利用者都合のキャンセル料\n・サービス提供に伴う材料費(医療材料を除く)",
    cancel_policy: "訪問予定日の前日17時までにキャンセルの連絡がない場合、所定のキャンセル料(訪問看護費の半額相当)を申し受ける場合があります。ただし、体調不良・入院等やむを得ない場合はこの限りではありません。",
    emergency_hours: "24時間365日(24時間対応体制加算ご契約の場合)",
    emergency_policy: "24時間対応体制加算をご契約いただいた利用者様については、夜間・休日も含め緊急時に当事業所の看護師が電話相談・必要時の緊急訪問に対応します。緊急搬送が必要な場合は救急要請を行い、主治医へ速やかに連絡します。",
    privacy_policy: "当事業所では、利用者の個人情報及び医療情報について、個人情報保護法及び関連ガイドラインに基づき厳重に管理します。利用目的は主に、①訪問看護サービスの提供、②介護・医療保険請求事務、③主治医・ケアマネジャー等多職種連携、④事業所内での情報共有及びケアの質向上のためであり、本人の同意を得ずに第三者へ提供することはありません。",
    complaint_third_party: "(都道府県国民健康保険団体連合会及び市区町村の介護保険担当課を第三者相談窓口としてご利用いただけます。)",
  },

  contract: {
    contract_period_note: "契約期間満了日の30日前までに双方から書面による申出がない場合、本契約は同一条件で自動的に更新されるものとします。",
    service_content: "事業所は、利用者に対して、主治医の訪問看護指示書及び訪問看護計画書に基づき、療養上の世話及び診療の補助を提供します。提供内容は重要事項説明書に記載のとおりとします。",
    frequency_time: "訪問頻度及び訪問時間は、主治医の指示書、利用者の状態及びケアプランを踏まえ、訪問看護計画書により定めます。変更が生じる場合は事前にご相談のうえ調整します。",
    payment_method: "口座引き落とし",
    termination_conditions: "次の各号のいずれかに該当する場合、本契約は終了または解除されるものとします。\n① 利用者の死亡、入院または施設入所により在宅療養が困難となった場合\n② 利用者またはその家族から書面により解除の申出があった場合\n③ 利用者またはご家族が、従業者に対し、合理的理由なく暴力・セクシュアルハラスメント等の行為を繰り返した場合\n④ 利用料金の滞納が相当期間継続した場合\n⑤ 事業者の廃業等による場合(原則として1ヶ月以上前に通知するものとする)",
    penalty_policy: "違約金は原則として発生しません。ただし、契約に著しく反する行為があった場合はこの限りではありません。",
    liability: "事業所は、サービス提供に伴い、事業者の責に帰すべき事由により利用者の身体・財産に損害を与えた場合、速やかに損害を賠償します。ただし、不可抗力による場合、または利用者の故意・重過失による場合はこの限りではありません。",
    insurance: "当事業所は、訪問看護事業者賠償責任保険に加入しています。",
  },

  // === 同意書 ===
  consent_pi: {
    purposes: "当事業所では、利用者の個人情報を以下の目的のために使用させていただきます。\n\n1. 訪問看護サービスの提供に関すること\n2. 主治医・医療機関・ケアマネジャー・他の介護サービス事業者・行政機関との情報共有及び連携\n3. 介護報酬・診療報酬の請求事務\n4. 事業所内の看護・介護の質向上のための症例検討、研修、会議等での使用\n5. 訪問看護計画書・報告書の作成及び関係者への提示\n6. 事故発生時の家族・関係機関への連絡\n7. 匿名化処理を行った上での、研究・統計目的での使用",
    third_party_sharing: "主治医、医療機関、担当ケアマネジャー、居宅介護支援事業所、他の介護サービス事業者、薬局、保険者(市区町村・保険者)、行政機関、地域包括支援センター等、サービス提供に必要な範囲で情報を共有します。",
    retention_period: "訪問看護記録等の個人情報は、介護保険法及び関連法令に基づき、サービス終了後2年間(医療保険関連は5年間、看護記録は所定期間)保存したうえで、適切な方法により廃棄いたします。",
    withdrawal_policy: "本同意は、利用者または代理人の書面による申出により、いつでも撤回することができます。ただし、撤回前になされた情報提供の取消しはできません。",
    agree_internal_share: true,
    agree_doctor_share: true,
    agree_multidisciplinary: true,
    agree_family: true,
    agree_research: false,
  },

  consent_emergency: {
    consent_scope: "訪問看護提供中またはそれ以外の時間帯に、利用者の心身状態に急変・異常が生じた場合に、訪問看護師が必要と判断した下記対応を行うことに同意します。\n\n・バイタルサインの測定及び応急処置\n・主治医への連絡及び指示受け\n・必要時の救急搬送要請(119番通報)\n・家族・キーパーソンへの連絡\n・緊急時訪問看護の実施",
    emergency_visit: true,
    ambulance_call: true,
    doctor_contact: true,
    family_contact: true,
  },

  consent_medical_share: {
    sharing_partners: "主治医、主治医の所属する医療機関、担当ケアマネジャー、居宅介護支援事業所、他の訪問看護・介護サービス事業者、薬局、地域包括支援センター、保険者等、利用者のケアに関わる関係者。",
    shared_info: "病名・病歴、現在の健康状態、バイタルサイン、ADL、服薬状況、医療処置の内容、看護計画、看護経過、精神症状・認知機能、家族状況その他、サービス提供に必要な医療・介護情報。",
    purpose: "安全かつ質の高い在宅療養を支援するための多職種連携、情報共有、ケアの継続性の確保を目的とします。",
    agree_sharing: true,
  },

  // === 計画・アセスメント ===
  service_plan: {
    living_situation: "",
    main_diagnosis_detail: "",
    adl_summary: "",
    goal: "本人の尊厳と自立を尊重し、住み慣れた在宅での療養生活を継続できるよう支援する。",
    short_goal: "・健康状態を安定して維持する\n・日々の生活リズムを整える\n・家族介護者の介護負担を軽減する",
    service_details: "1. 健康状態の観察(バイタル測定、症状確認)\n2. 服薬管理・服薬指導\n3. 清潔ケア(清拭、陰部洗浄、口腔ケア 等)\n4. 排泄ケア\n5. 医療処置(主治医指示による)\n6. 家族への介護相談・指導\n7. 主治医・ケアマネジャー等関係者との情報共有",
  },

  assessment: {
    assess_type: "初回",
    pain: "特記事項なし",
    communication: "意思疎通可能。質問に対して応答あり。",
    sleep: "夜間の睡眠時間は確保されている。日中の傾眠なし。",
    nursing_direction: "本人の希望・家族の介護力を踏まえ、在宅での療養生活を安定して継続できるよう、主治医・ケアマネと連携して看護ケアを提供する。",
  },

  care_plan_draft: {
    long_goal: "在宅療養生活を安定して継続することができる。",
    short_goal: "・健康状態の悪化を早期に発見できる\n・症状コントロールが図れる\n・本人・家族が不安なく過ごせる",
    nursing_content: "1. 健康状態の観察\n   - バイタルサイン(体温・血圧・脈拍・SpO2)の測定\n   - 症状の有無と程度の観察\n2. 療養上の世話\n   - 清潔ケアの援助\n   - 排泄ケアの援助\n   - 体位変換・褥瘡予防ケア\n3. 医療処置(主治医指示に基づく)\n4. 服薬管理・服薬状況の確認\n5. 家族への介護指導・相談対応\n6. 主治医・ケアマネジャー等関係者との情報共有",
    frequency: "週1〜2回 60分/回",
    evaluation_plan: "1ヶ月ごとにモニタリングを実施し、看護計画の達成状況・変化を評価する。必要に応じて計画を修正する。",
  },

  care_plan_final: {
    long_goal: "在宅療養生活を安定して継続することができる。",
    short_goal: "・健康状態の悪化を早期に発見できる\n・症状コントロールが図れる\n・本人・家族が不安なく過ごせる",
    nursing_content: "1. 健康状態の観察\n   - バイタルサイン(体温・血圧・脈拍・SpO2)の測定\n   - 症状の有無と程度の観察\n2. 療養上の世話\n   - 清潔ケアの援助\n   - 排泄ケアの援助\n   - 体位変換・褥瘡予防ケア\n3. 医療処置(主治医指示に基づく)\n4. 服薬管理・服薬状況の確認\n5. 家族への介護指導・相談対応\n6. 主治医・ケアマネジャー等関係者との情報共有",
    frequency: "週1〜2回 60分/回",
    evaluation_plan: "1ヶ月ごとにモニタリングを実施し、看護計画の達成状況・変化を評価する。",
    collaboration: "主治医・ケアマネジャー・ヘルパー事業所と、訪問看護報告書及びサービス担当者会議を通じて情報共有を行う。",
    consent_received: true,
  },

  care_plan_psych: {
    psych_symptoms: "(主な精神症状・観察事項を記載)",
    medication_adherence: "処方薬を自己管理中。服薬カレンダーを使用し、毎日確認を継続する。",
    long_goal: "症状が安定し、地域で自分らしい生活を継続することができる。",
    short_goal: "・服薬を継続できる\n・症状の悪化を早期に察知・対処できる\n・対人関係・日中活動を維持できる",
    care_content: "1. 精神症状の観察・アセスメント\n2. 服薬管理支援・服薬アドヒアランス維持\n3. 生活リズムの維持支援(睡眠・食事・活動)\n4. 対人関係・社会参加への支援\n5. 家族支援・家族心理教育\n6. 主治医・地域多職種との連携",
    family_support_plan: "家族への疾患理解促進・対応方法の助言。必要に応じて家族会・相談窓口の情報提供を行う。",
    crisis_plan: "症状悪化時の連絡体制:①利用者→訪問看護ステーション→主治医の順で連絡\n希死念慮出現時は速やかに主治医・家族へ連絡し、必要時は救急搬送または精神科受診を調整する。",
  },

  // === 会議・連携 ===
  service_meeting: {
    organizer: "担当ケアマネジャー",
    agenda: "1. 利用者の現在の状況\n2. 各サービス提供状況の報告\n3. ケアプラン・サービス内容の妥当性検討\n4. 次回計画に向けた調整",
  },

  discharge_coop: {
    care_instructions: "1. 服薬管理方法\n2. 医療処置の手技・注意点\n3. バイタル異常時の対応\n4. 緊急時の連絡先\n5. 次回外来受診日・持参物品",
  },

  // === 記録・報告 ===
  monitoring: {
    plan_revision: "継続(変更なし)",
  },

  nursing_report: {
    report_to: "",
  },

  instruction_request: {
    request_type: "継続",
    doctor_honorific: "先生 御侍史",
    greeting_body: "　謹啓、時下ますますご清栄のこととお喜び申し上げます。\n\nさて、ご多忙中まことに恐れ入りますが、下記の方が訪問看護（リハビリテーション）を希望しておりますので、御高診を賜り別紙指示書にご記入頂きたくお願い申し上げます。",
    req_nursing_instruction: true,
    visit_content: "看護",
    self_support_type: "更新",
    self_support_cert_needed: "要",
  },

  // === 緊急・リスク ===
  emergency_plan: {
    anticipated_situations: "・バイタルサインの急激な悪化(発熱、血圧低下・上昇、意識障害 等)\n・転倒・転落事故\n・医療機器のトラブル(在宅酸素、吸引器、輸液ポンプ 等)\n・服薬トラブル(過量・誤薬 等)\n・火災・地震・水害等の災害時",
    ambulance_criteria: "以下のいずれかに該当する場合、救急要請(119番)を行う。\n・意識レベルの急激な低下・消失\n・呼吸困難・SpO2の著明な低下\n・胸痛・激しい腹痛の出現\n・大量出血\n・痙攣発作\n・主治医と連絡不能で緊急対応が必要と判断される場合",
    response_steps: "1. 安全確保・利用者の意識・呼吸・循環を確認\n2. バイタルサイン測定・症状観察\n3. 必要時応急処置(気道確保、止血等)\n4. 主治医への連絡・指示受け\n5. 救急要請の要否判断(救急要請基準に従う)\n6. 家族・キーパーソンへの連絡\n7. 訪問看護ステーションへの報告\n8. 経過観察・記録",
    evacuation_route: "避難経路:玄関→表通り→指定避難場所(市区町村指定一時避難場所)\n車椅子・杖使用者の場合の介助者・搬送方法を事前に家族と確認。",
    disaster_plan: "【地震発生時】\n・家具転倒・物品落下から利用者を守る\n・医療機器の安全確認\n・家屋損壊時は速やかに避難\n\n【停電時】\n・在宅酸素・呼吸器使用者は予備電源・酸素ボンベに切り替え\n・主治医・酸素供給業者へ速やかに連絡\n\n【水害・台風時】\n・気象情報を確認し、早期避難を促す\n・避難行動要支援者として行政・消防へ情報共有済",
  },

  accident_report: {},

  hiyari_hatto: {
    level: "レベル1(影響なし)",
  },

  complaint: {
    status: "受付",
  },

  // === 看取り・終了 ===
  end_of_life_consent: {
    place_of_care: "自宅",
    policy: "本人の尊厳と意思を最大限尊重し、苦痛を最小限に抑えた穏やかな最期を迎えることを目標とします。延命を目的とした過剰な医療処置は行わず、症状緩和を最優先としたケアを提供します。本人・ご家族の精神的サポート、及びグリーフケアも継続的に行います。",
    advance_directive: "本人の事前意思は(    )のとおりです。心肺停止時の蘇生処置、人工呼吸器装着、経管栄養、中心静脈栄養等については本人・家族と主治医の間で確認済です。",
    doctor_coop: "主治医と24時間の連絡体制を確認。訪問看護ステーションと主治医の間で看取り体制を整備し、死亡確認は主治医または連携医療機関の医師が行います。",
    agree_palliative: true,
  },

  service_end: {
    reason: "その他",
  },
};

export const getDefaultContent = (docType) => DEFAULT_CONTENT[docType] || {};
